module.exports = __webpack_public_path__ + "img/jnzn.c4c005e3.png";